import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/snowflake.vue
var s = {
	name: "DtIconSnowflake",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--snowflake"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Snowflake",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		d: "M1 5.5a.5.5 0 0 0 0 1h1.793L1.646 7.646a.5.5 0 1 0 .708.708L4.207 6.5h1.147l.146.024v1.269L3.646 9.646a.5.5 0 0 0 .708.708L5.5 9.207V11a.5.5 0 0 0 1 0V9.207l1.146 1.147a.5.5 0 0 0 .708-.708L6.5 7.793V6.5h1.293l1.853 1.854a.5.5 0 0 0 .708-.708L9.207 6.5H11a.5.5 0 0 0 0-1H9.207l1.147-1.146a.5.5 0 0 0-.708-.708L7.793 5.5H6.5V4.207l1.854-1.853a.5.5 0 1 0-.708-.708L6.5 2.793V1a.5.5 0 0 0-1 0v1.793L4.354 1.646a.5.5 0 1 0-.708.708L5.5 4.207V5.5H4.207L2.354 3.646a.5.5 0 1 0-.708.708L2.793 5.5H1Z",
		fill: "currentColor"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=snowflake.js.map